import { isConfigurableServer } from '@festina-life/core'
import { useParams } from 'react-router'

import type { TemplateRouteParams } from '../system/types'

/** Helper hook for retrieving the current Server from the query params.*/
export const useServer = () => {
  const { server } = useParams<TemplateRouteParams>()

  if (!server || !isConfigurableServer(server)) {
    throw new Error(`Invalid server: ${server}`)
  }

  return server
}
